export enum PolicyEnum {
  VIEW_USER_MANAGEMENT = "HamburgerMenu.UserManagement.View",
  VIEW_RAISE_TICKET = "Ticket.RaiseTicket.View",
  VIEW_ACTIVE_TICKET = "Ticket.ActiveTicketList.View",
  VIEW_CLOSE_TICKET = "Ticket.ClosedTicketList.View",
  VIEW_THREE_DOTS = "Ticket.3dots.View",
  VIEW_TICKET_RESOLVED_ACTION = "Ticket.resolved.View",
  VIEW_TICKET_SHARE_ACTION = "Ticket.share.View",
  VIEW_CHAT_VIDEO_ICON = "Chat.Videoicon.View",
  VIEW_MEDIA_AND_FILES_ICON = "Chat.AttachImage/Video/Document.View",
  VIEW_CHAT_AUDIO_ICON = "Chat.AudioIcon.View",
  VIEW_CHAT_CAMERA_ICON = "Chat.Cameraicon.View",
  VIEW_CHAT_RESOLVED_ACTION = "Chat.Resolvedaction.View",
  VIEW_CHAT_SHARE_ACTION = "Chat.Shareaction.View",
  VIEW_ADD_USER = "UserManagement.AddUser.View",
  VIEW_USER_FIRST_NAME = "UserManagement.FirstName.View",
  VIEW_USER_LAST_NAME = "UserManagement.LastName.View",
  VIEW_USER_ASSIGN_SECURITY_GROUP = "UserManagement.AssignSecurityGroup.View",
  VIEW_USER_EMAIL = "UserManagement.PrimaryEmailId.View",
  VIEW_USER_COUNTRY_CODE = "UserManagement.CountryCode.View",
  VIEW_USER_CONTACT = "UserManagement.PrimaryContactNumber.View",
  VIEW_USER_STATUS = "UserManagement.Userstatus.View",
  VIEW_PROFILE_FIRST_NAME = "MyProfile.FirstName.View",
  VIEW_PROFILE_LAST_NAME = "MyProfile.LastName.View",
  VIEW_PROFILE_ASSIGN_SECURITY = "MyProfile.AssignSecurityGroup.View",
  VIEW_PROFILE_ADDRESS_LINE = "MyProfile.AddressLine#1.View",
  VIEW_PROFILE_USER_APARTMENT = "MyProfile.Suite,Apartment,etc.View",
  VIEW_PROFILE_USER_CITY = "MyProfile.City.View",
  VIEW_PROFILE_USER_STATE = "MyProfile.State/Country.View",
  VIEW_PROFILE_ZIPCODE = "MyProfile.ZipCode/PostalCode.View",
  VIEW_PROFILE_USER_COUNTRY = "MyProfile.Country.View",
  VIEW_PROFILE_USER_CONTACT = "MyProfile.PrimaryContactNumber.View",
  VIEW_PROFILE_USER_EMAIL = "MyProfile.PrimaryEmailID.View",
  VIEW_CHANGE_PASSWORD = "ChangePassword.NewPassword.View",

  EDIT_USER_MANAGEMENT = "HamburgerMenu.UserManagement.Edit",
  EDIT_RAISE_TICKET = "Ticket.RaiseTicket.Edit",
  EDIT_ACTIVE_TICKET = "Ticket.ActiveTicketList.Edit",
  EDIT_THREE_DOTS = "Ticket.3dots.Edit",
  EDIT_TICKET_RESOLVED_ACTION = "Ticket.resolved.Edit",
  EDIT_TICKET_SHARE_ACTION = "Ticket.share.Edit",
  EDIT_CHAT_VIDEO_ICON = "Chat.Videoicon.Edit",
  EDIT_MEDIA_AND_FILES_ICON = "Chat.AttachImage/Video/Document.Edit",
  EDIT_CHAT_AUDIO_ICON = "Chat.AudioIcon.Edit",
  EDIT_CHAT_CAMERA_ICON = "Chat.Cameraicon.Edit",
  EDIT_CHAT_RESOLVED_ACTION = "Chat.Resolvedaction.Edit",
  EDIT_CHAT_SHARE_ACTION = "Chat.Shareaction.Edit",
  EDIT_ADD_USER = "UserManagement.AddUser.Edit",
  EDIT_USER_FIRST_NAME = "UserManagement.FirstName.Edit",
  EDIT_USER_LAST_NAME = "UserManagement.LastName.Edit",
  EDIT_USER_ASSIGN_SECURITY_GROUP = "UserManagement.AssignSecurityGroup.Edit",
  EDIT_USER_EMAIL = "UserManagement.PrimaryEmailId.Edit",
  EDIT_USER_COUNTRY_CODE = "UserManagement.CountryCode.Edit",
  EDIT_USER_CONTACT = "UserManagement.PrimaryContactNumber.Edit",
  EDIT_USER_STATUS = "UserManagement.Userstatus.Edit",
  EDIT_PROFILE_FIRST_NAME = "MyProfile.FirstName.Edit",
  EDIT_PROFILE_LAST_NAME = "MyProfile.LastName.Edit",
  EDIT_PROFILE_ASSIGN_SECURITY = "MyProfile.AssignSecurityGroup.Edit",
  EDIT_PROFILE_ADDRESS_LINE = "MyProfile.AddressLine#1.Edit",
  EDIT_PROFILE_USER_APARTMENT = "MyProfile.Suite,Apartment,etc.Edit",
  EDIT_PROFILE_USER_CITY = "MyProfile.City.Edit",
  EDIT_PROFILE_USER_STATE = "MyProfile.State/Country.Edit",
  EDIT_PROFILE_ZIPCODE = "MyProfile.ZipCode/PostalCode.Edit",
  EDIT_PROFILE_USER_COUNTRY = "MyProfile.Country.Edit",
  EDIT_PROFILE_USER_CONTACT = "MyProfile.PrimaryContactNumber.Edit",
  EDIT_PROFILE_USER_EMAIL = "MyProfile.PrimaryEmailID.Edit",
  EDIT_CHANGE_PASSWORD = "ChangePassword.NewPassword.Edit",
}
